import { render, staticRenderFns } from "./RecipientForm.vue?vue&type=template&id=1a9abc20&scoped=true&"
import script from "./RecipientForm.vue?vue&type=script&lang=js&"
export * from "./RecipientForm.vue?vue&type=script&lang=js&"
import style0 from "./RecipientForm.vue?vue&type=style&index=0&id=1a9abc20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9abc20",
  null
  
)

export default component.exports